import React from "react";
// Components
import MainTable from '../../Components/Tables/Main/MainTable'
import ButtonSwitchBetweenTables from '../../Components/Buttons/ButtonSwitchBetweenTables'
// Hooks
import { useAlerts } from "../../Hooks/useAlerts";
import { useVehicles } from "../../Hooks/useVehicles";
// Libraries
import { useParams, useHistory } from "react-router-dom";
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
// Constants
import { alertTypes, resolveTimezoneOffsetError } from "../../CommonConstants";
const propertyAlerts = { ...alertTypes}
delete propertyAlerts.maintenance

const Alerts = () => {
    let { vehicleId } = useParams();
    const [alertsData, addAlert, updateAlert, deleteAlert] = useAlerts(vehicleId);

    const history = useHistory();

    const navigateToVehicleMaintenanceAlerts = () => history.push(`/vehicle/${vehicleId}/alerts/maintenance`)

    const [vehiclesData] = useVehicles(true);

    const vehicle = vehiclesData.find(({ id }) => id === +vehicleId);
    let vehicleName = "";
    if (vehicle) {
        const { brand, model, patent } = vehicle;
        vehicleName = `${brand} ${model} ${patent}`;
    }

    const columns = [
        { title: "Id", field: "id", hidden: true },
        { title: "Descripción", field: "description" },
        { title: "Tipo", field: "type", lookup: propertyAlerts, editable: "onAdd" },
        { title: "Días de preaviso", field: "daysForewarning", type: "numeric" },
        {
            title: "Fecha de acción", field: "actionDate", defaultSort: 'asc', type: "date",
            render: row => row.actionDate ? <span>{resolveTimezoneOffsetError(row.actionDate, 'dd/MM/yyyy')}</span> : <span></span>,
            editComponent: props => (
                <MuiPickersUtilsProvider utils={DateFnsUtils}
                    locale={props.dateTimePickerLocalization}>
                    <DatePicker
                        format="dd/MM/yyyy"
                        value={props.value ? resolveTimezoneOffsetError(props.value) : null}
                        onChange={props.onChange}
                        clearable
                        InputProps={{
                            style: {
                                fontSize: 13,
                            }
                        }}
                    />
                </MuiPickersUtilsProvider>
            )
        }
    ];

    return (
        <div>
            <ButtonSwitchBetweenTables text={'Ver alertas de mantenimiento'} onClick={navigateToVehicleMaintenanceAlerts} />
            <MainTable
                title={`Alertas de ${vehicleName}`}
                columns={columns}
                data={alertsData}
                requiredFields={["description", "actionDate", "type", "daysForewarning"]}
                deleteText="Se desactivará la alerta"
                onRowAdd={async (newData) => {
                    const dataToSave = { ...newData }
                    dataToSave.actionDate = dataToSave.actionDate ? resolveTimezoneOffsetError(dataToSave.actionDate, 'yyyy-MM-dd') : null
                    await addAlert(dataToSave)
                }}
                onRowUpdate={async (newData) => {
                    const dataToSave = { ...newData }
                    delete dataToSave.fileId
                    delete dataToSave.id
                    delete dataToSave.type
                    dataToSave.actionDate = dataToSave.actionDate ? resolveTimezoneOffsetError(dataToSave.actionDate, 'yyyy-MM-dd') : null
                    await updateAlert(dataToSave, newData.id)
                }}
                onRowDelete={async (newData) => await deleteAlert(newData.id)}
            />
        </div>)
}

export default Alerts


// WEBPACK FOOTER //
// ./src/Containers/VehicleAlerts/VehicleAlerts.js